import axios from "axios";
import { googleApiKey } from "../../../utils/constants";
import { notification } from "antd";

export const currencyFormatter = (value, separator = true) => {
  const removeChar = value.replace("'", "");

  var removeSpecialChar = removeChar.replace(
    /[`~!@#$%^&*()_|+\=?;:'",<>\{\}\[\]\\\/]/gi,
    "",
  );

  const numberOnly = removeSpecialChar.replace(/[^\d.-]/g, "");
  // Old way
  // return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  if (numberOnly === "") {
    return 0;
  }

  let parserFoat = parseFloat(numberOnly)
    .toFixed(3)
    .slice(0, -1);


  if (separator) {
    return parserFoat.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  } else {
    return parserFoat;
  }
};

export async function validateGoogleAddress(rule, value) {
  if (!value) {
    return Promise.reject("L'adresse est requise");
  }

  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
    value,
  )}&key=${googleApiKey}`;

  try {
    const response = await axios.get(url);
    if (response.data.status === "OK" && response.data.results.length > 0) {
      const result = response.data.results[0];
      const locationType = result.geometry.location_type;

      // Vérifier si l'adresse est précise
      if (locationType === "APPROXIMATE") {
        notification.error({
          message: "L'adresse doit être plus précise (rue + localité).",
          // description: error.message,
        });
        return Promise.reject(
          "L'adresse doit être plus précise (rue + localité).",
        );
      }

      // Extraire la localité des address_components
      const localityComponent = result?.address_components?.find(component =>
        component.types.includes("locality"),
      );

      if (!localityComponent) {
        notification.error({
          message: "L'adresse doit inclure une localité (ville ou village).",
          // description: error.message,
        });
        return Promise.reject(
          "L'adresse doit inclure une localité (ville ou village).",
        );
      }

      const locality = localityComponent.long_name;

      // Vérifier si la localité est présente dans l'adresse fournie
      // if (!value.toLowerCase().includes(locality.toLowerCase())) {
      //   notification.error({
      //     message: `L'adresse doit inclure la localité "${locality}".`,
      //     // description: error.message,
      //   });
      //   return Promise.reject(
      //     `L'adresse doit inclure la localité "${locality}".`,
      //   );
      // }

      return Promise.resolve();
    } else {
      return Promise.reject("Cette adresse ne semble pas valide");
    }
  } catch (error) {
    return Promise.reject("Erreur de validation de l'adresse");
  }
}
